(() => {
  const internalHosts = new Set([location.hostname.replace(/^www\./, ''), 'dtfprintcentral.com', '8f6gh6-b0.myshopify.com']);
  function updateLink(link) {
    const href = link.getAttribute('href');
    if (!href) return;
    let url;
    try { url = new URL(href, document.baseURI); } catch { return; }
    if (!['http:', 'https:'].includes(url.protocol) || internalHosts.has(url.hostname.replace(/^www\./, ''))) return;
    link.target = '_blank';
    const rel = new Set((link.getAttribute('rel') || '').split(/\s+/).filter(Boolean));
    rel.add('noopener');
    link.setAttribute('rel', [...rel].join(' '));
  }
  function scan(root) {
    if (root instanceof Element && root.matches('a[href]')) updateLink(root);
    root.querySelectorAll?.('a[href]').forEach(updateLink);
  }
  scan(document);
  new MutationObserver(records => {
    records.forEach(record => {
      if (record.type === 'attributes') updateLink(record.target);
      else record.addedNodes.forEach(scan);
    });
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
})();